"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _FooterUEPB = require("../structure/FooterUEPB");

var _FooterUEPB2 = _interopRequireDefault(_FooterUEPB);

require("../../assets/css/components/error/UnsupportedBrowser.css");

var _chrome_logo_ = require("../../assets/img/navegadores/chrome_logo_120.png");

var _chrome_logo_2 = _interopRequireDefault(_chrome_logo_);

var _Mozilla_Firefox_ = require("../../assets/img/navegadores/Mozilla_Firefox_120.png");

var _Mozilla_Firefox_2 = _interopRequireDefault(_Mozilla_Firefox_);

var _operaBrowser = require("../../assets/img/navegadores/opera-browser-120.png");

var _operaBrowser2 = _interopRequireDefault(_operaBrowser);

var _Safari = require("../../assets/img/navegadores/Safari-120.png");

var _Safari2 = _interopRequireDefault(_Safari);

var _edge = require("../../assets/img/navegadores/edge-120.png");

var _edge2 = _interopRequireDefault(_edge);

var _View2 = require("../view/View");

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnsupportedBrowser = function (_View) {
    _inherits(UnsupportedBrowser, _View);

    function UnsupportedBrowser() {
        _classCallCheck(this, UnsupportedBrowser);

        return _possibleConstructorReturn(this, (UnsupportedBrowser.__proto__ || Object.getPrototypeOf(UnsupportedBrowser)).apply(this, arguments));
    }

    _createClass(UnsupportedBrowser, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            var isIE = /*@cc_on!@*/false || !!document.documentMode;
            if (!isIE) {
                this.redirect('/');
            }
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "unsupported-browser-page" },
                _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "mensagem" },
                        _react2.default.createElement(
                            "p",
                            null,
                            "Navegador n\xE3o suportado :("
                        ),
                        _react2.default.createElement(
                            "div",
                            null,
                            "Para obter a melhor experi\xEAncia poss\xEDvel usando o nosso site, recomendamos que voc\xEA utilize a vers\xE3o mais recente de outro navegador da Web. Uma lista dos navegadores mais populares pode ser encontrada abaixo."
                        ),
                        _react2.default.createElement(
                            "div",
                            null,
                            "Apenas clique sobre o icone para ser redirecionado para a p\xE1gina de download."
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "lista-navegadores" },
                        _react2.default.createElement(
                            "ul",
                            null,
                            _react2.default.createElement(
                                "li",
                                null,
                                _react2.default.createElement(
                                    "a",
                                    { href: "https://www.google.com.br/intl/pt-BR/chrome/", title: "Link para download do navegador Google Chrome" },
                                    _react2.default.createElement("img", { src: _chrome_logo_2.default, alt: "Logo navegador Google Chrome" }),
                                    _react2.default.createElement(
                                        "p",
                                        null,
                                        _react2.default.createElement(
                                            "b",
                                            null,
                                            "Google Chrome"
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                "li",
                                null,
                                _react2.default.createElement(
                                    "a",
                                    { href: "https://www.mozilla.org/pt-BR/firefox/new/", title: "Link para download do navegador Firefox" },
                                    _react2.default.createElement("img", { src: _Mozilla_Firefox_2.default, alt: "Logo navegador Firefox" }),
                                    _react2.default.createElement(
                                        "p",
                                        null,
                                        _react2.default.createElement(
                                            "b",
                                            null,
                                            "Firefox"
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                "li",
                                null,
                                _react2.default.createElement(
                                    "a",
                                    { href: "https://www.opera.com/pt-br/download", title: "Link para download do navegador Opera" },
                                    _react2.default.createElement("img", { src: _operaBrowser2.default, alt: "Logo navegador Opera" }),
                                    _react2.default.createElement(
                                        "p",
                                        null,
                                        _react2.default.createElement(
                                            "b",
                                            null,
                                            "Opera"
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                "li",
                                null,
                                _react2.default.createElement(
                                    "a",
                                    { href: "https://support.apple.com/pt_BR/downloads/safari", title: "Link para download do navegador Safari" },
                                    _react2.default.createElement("img", { src: _Safari2.default, alt: "Logo navegador Safari" }),
                                    _react2.default.createElement(
                                        "p",
                                        null,
                                        _react2.default.createElement(
                                            "b",
                                            null,
                                            "Safari"
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                "li",
                                null,
                                _react2.default.createElement(
                                    "a",
                                    { href: "https://www.microsoft.com/pt-br/windows/microsoft-edge", title: "Link para download do navegador Edge" },
                                    _react2.default.createElement("img", { src: _edge2.default, alt: "Logo navegador Edge" }),
                                    _react2.default.createElement(
                                        "p",
                                        null,
                                        _react2.default.createElement(
                                            "b",
                                            null,
                                            "Edge"
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_FooterUEPB2.default, null)
            );
        }
    }]);

    return UnsupportedBrowser;
}(_View3.default);

exports.default = UnsupportedBrowser;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/error/UnsupportedBrowser.js
// module id = 1117
// module chunks = 0